<template>
    <div class="custom-control custom-radio custom-control-inline">
        <input @click="handleClick" :checked="active" type="radio" :id="`donation-amount-${$options.filters.replaceDotWithDash(amount)}`"
               :name="`donation-amount`" class="custom-control-input" :value="`${donationAmount}`">
        <label class="custom-control-label" :for="`donation-amount-${$options.filters.replaceDotWithDash(amount)}`">€ {{ amount | replaceDotWithComma }}</label>
    </div>
</template>

<script>
export default {
    name: "DonationAmount",

    props: ['amount', 'eventBus'],

    data() {
        return {
            donationAmount: (parseFloat(this.amount) * 100),
            active: false
        }
    },

    filters: {
        replaceDotWithComma(value) {
            return value.replace('.', ',')
        },

        replaceDotWithDash(value) {
            return value.replace('.', '-')
        }
    },

    mounted() {
        this.eventBus.$on('active-amount', (payload) => {
            this.active = (payload === parseFloat(this.amount));
        });

        this.eventBus.$on('remove-active-state', () => this.active = false);
    },

    methods: {
        handleClick() {
            this.eventBus.$emit('active-amount', parseFloat(this.amount));

            if (_.isNil(this.donationAmount)) {
                return;
            }

            this.$emit('donation-amount', this.donationAmount);
        }
    }
}
</script>